import { useState } from "react";
import {
  Row,
  Col,
  Alert,
  Card,
  CardBody,
  Container,
  FormFeedback,
  Input,
  Label,
  Form,
} from "reactstrap";

//redux
import { useSelector, useDispatch } from "react-redux";

import { withRouter, Link, useHistory } from "react-router-dom";

// Formik Validation
import * as Yup from "yup";
import { useFormik } from "formik";

// action
import { forgetPassword } from "../../store/actions";

// import images
// import profile from "../../assets/images/bg.png";
import logo from "../../assets/images/logo.png";
import { ParticlesAuth } from "../AuthenticationInner";
import { useTranslation } from "react-i18next";
import { ForgetPasswordRequest, State } from "../../interfaces";
import { ActivityButton } from "../../components/Common";
import LanguageDropdown from "../../components/Common/LanguageDropdown";

const ForgetPasswordPageComponent = (props: any) => {
  const history = useHistory();
  const dispatch = useDispatch();
  const { t } = useTranslation();
  document.title = `${t("documentTitle", { pageName: "forgetPassword" })}`;

  const [forgetPasswordRequest] = useState<ForgetPasswordRequest>({
    countryCode: process.env.REACT_APP_COUNTRY_CODE || "965",
    phoneNumber: "",
  });

  const { loading, error, success } = useSelector(
    (state: any): State<any> => state.auth.forget
  );

  //#region form
  const form = useFormik({
    enableReinitialize: true,
    initialValues: {
      countryCode: forgetPasswordRequest.countryCode,
      phoneNumber: forgetPasswordRequest.phoneNumber,
    },
    initialErrors: error,
    validationSchema: Yup.object({
      phoneNumber: Yup.string().required(
        t("isNotEmpty", {
          displayName: "phoneNumber",
        })
      ),
    }),

    onSubmit: (values) => {
      dispatch(forgetPassword(values, history));
    },
  });
  //#endregion

  return (
    <ParticlesAuth>
      <div className="auth-page-content">
        <Container>
          <Row className="justify-content-center">
            <Col md={8} lg={6} xl={5}>
              <Card className="mt-4">
                <CardBody className="p-4">
                  <div className="text-center mt-1">
                    <img src={logo} alt="" height="100" width="100" />
                    <h5 className="text-primary mt-2">
                      {t("forgetPassword?")}
                    </h5>
                    <p className="text-muted">
                      {t("forgetPasswordSubHeading")}
                    </p>
                  </div>
                  <div className="mt-4">
                    <div className="justify-content-center align-items-center d-flex">
                      <LanguageDropdown />
                    </div>

                    <Form
                      onSubmit={(e) => {
                        e.preventDefault();
                        form.handleSubmit();
                        return false;
                      }}
                    >
                      <div className="mb-3">
                        <Label htmlFor="phoneNumber" className="form-label">
                          {t("phoneNumber")}
                        </Label>
                        <span className="text-danger">*</span>
                        <Input
                          autoComplete="off"
                          id="phoneNumber"
                          name="phoneNumber"
                          className="form-control"
                          placeholder={t("enterPhoneNumber")}
                          type="text"
                          onBlur={form.handleBlur}
                          value={form.values.phoneNumber || ""}
                          invalid={
                            form.touched.phoneNumber && form.errors.phoneNumber
                              ? true
                              : false
                          }
                          maxLength={12}
                          onChange={(e) => {
                            e.preventDefault();
                            const { value } = e.target;
                            const regex =
                              /^(0*[0-9][0-9]*(\.[0-9]*)?|0*\.[0-9]*[1-9][0-9]*)$/;
                            if (regex.test(value.toString())) {
                              form.setValues({
                                ...form.values,
                                phoneNumber: value,
                              });
                            } else {
                              form.setValues({
                                ...form.values,
                                phoneNumber: "",
                              });
                            }
                          }}
                        />
                        {form.touched.phoneNumber && form.errors.phoneNumber ? (
                          <FormFeedback type="invalid">
                            {form.errors.phoneNumber as string}
                          </FormFeedback>
                        ) : null}
                      </div>

                      <div className="mt-4">
                        {typeof error === "string" && (
                          <Label className="invalid-feedback d-block">
                            {error}
                          </Label>
                        )}
                        <ActivityButton
                          title="sendVerificationCode"
                          inProgressTitle="sending"
                          color="success"
                          className="btn btn-success w-100"
                          type="submit"
                          inProgress={loading}
                          disabled={loading}
                        ></ActivityButton>
                      </div>
                    </Form>
                  </div>
                </CardBody>
              </Card>

              <div className="mt-4 text-center">
                <p className="mb-0 text-white">
                  {t("waitIRememberMyPassword")}...{" "}
                  <Link
                    to="/login"
                    className="fw-semibold text-white text-decoration-underline"
                  >
                    {" "}
                    {t("clickHere")}{" "}
                  </Link>{" "}
                </p>
              </div>
            </Col>
          </Row>
        </Container>
      </div>
    </ParticlesAuth>
  );
};

export const ForgetPasswordPage = withRouter(ForgetPasswordPageComponent);
